import { Injectable } from "@angular/core";

import { AppHeaderTitleService } from "app/shared/components/app-header-title/app-header-title.service";
import { Subscription } from "rxjs";
import { tap, switchMap } from "rxjs/operators";
import { Yii } from "libraries/interfaces/Yii";
import { ResourceError } from "libraries/service/resource/ResourceError";
import { CachedQuotationService } from "../cached-quotation.service";

@Injectable()
export class AppHeaderTitleQuotationService {
    // Don't forget to unsubscribe in the component
    public readonly appHeaderTitleServiceSubscriptions: Subscription = new Subscription();

    constructor(
        private readonly appHeaderTitleService: AppHeaderTitleService,
        private readonly cachedQuotationService: CachedQuotationService,
    ) { }

    public changeTitle(quotationId: number): void {
        const titleEdition: Subscription = this.appHeaderTitleService.getHeaderTitle().pipe(
            tap(() => {
                this.appHeaderTitleService.setLoading({
                    isActive: true,
                    message: Yii.t('wui-quotation-js', 'Modification en cours')
                });
            }),
            switchMap((title: { title: string }) => this.cachedQuotationService.patch(title, quotationId))
        ).subscribe({
            next: (): void => {
                this.appHeaderTitleService.setLoading({
                    isActive: false,
                });
            },
            error: (error: ResourceError): void => {
                this.appHeaderTitleService.setError({
                    isActive: true,
                    message: error.message
                });
            }
        });

        this.appHeaderTitleServiceSubscriptions.add(titleEdition);
    }
}